import React from "react"
import { HStack, StackDivider } from "@chakra-ui/react"

import ProductWishlist from "@components/Product/ProductWishlist"
import ProductGiftRegistry from "@components/Product/ProductGiftRegistry"
import useProductQuickView from "@hooks/useProductQuickView"

const ProductQuickViewFooter = () => {
  const { product, location } = useProductQuickView()

  return (
    <HStack divider={<StackDivider />} spacing={[2.5, 4]} pb={2} alignSelf="center">
      <ProductWishlist loading={false} location={location} product={product} variant="text" />
      <ProductGiftRegistry product={product} collection={true} />
    </HStack>
  )
}

export default ProductQuickViewFooter
